import { ASSIGNED_REVIEW_TASK_TABS } from '../constants/assignedReviewTaskDomainConstants';

export function buildTableFiltersFromSearchParams(searchParams) {
  return {
    language: searchParams.get('language') ?? '',
    district: searchParams.get('district') ?? '',
    state: searchParams.get('state') ?? '',
    duration: searchParams.get('duration') ?? '',
    file_name: searchParams.get('file_name') ?? '',
    source_file: searchParams.get('source_file') ?? '',
    search: searchParams.get('search') ?? '',
  };
}

export function normalizeTabFromSearchParam(raw) {
  const tab = String(raw ?? ASSIGNED_REVIEW_TASK_TABS.NEW).toUpperCase();
  if (
    tab === ASSIGNED_REVIEW_TASK_TABS.NEW ||
    tab === ASSIGNED_REVIEW_TASK_TABS.APPROVED ||
    tab === ASSIGNED_REVIEW_TASK_TABS.REJECTED
  ) {
    return tab;
  }
  return ASSIGNED_REVIEW_TASK_TABS.NEW;
}
